import { forwardRef } from "react";
import { ReactComponent as Counter1Svg } from "imgs/Counter1.svg";
import { ReactComponent as Counter2Svg } from "imgs/Counter2.svg";
import { ReactComponent as Counter3Svg } from "imgs/Counter3.svg";
import type { SvgIconProps } from "@mui/material/SvgIcon";

import { TestProps } from "shared/types";

// Material Symbols counter_1..3 (weight 500); MUI's icon set has no circled digits.
const GLYPHS = { 1: Counter1Svg, 2: Counter2Svg, 3: Counter3Svg };

export type CounterValue = keyof typeof GLYPHS;

interface Props extends SvgIconProps, TestProps {
  value: CounterValue;
}

const CounterIcon = forwardRef<SVGSVGElement, Props>(
  ({ value, testId, ...props }, ref) => {
    const Glyph = GLYPHS[value];

    return (
      <Glyph ref={ref} {...props} data-testid={testId} fill="currentColor" />
    );
  }
);

export default CounterIcon;
